export type BonusUnavailableReason =
  | 'channel_inactive'
  | 'not_yet_active'
  | 'expired'
  | 'not_active'
  | 'stock_exhausted'
  | 'limit_reached'

export type BonusRedemptionRecord = {
  redeemable: boolean
  unavailable_reason?: BonusUnavailableReason | null
}

export const isBonusAlreadyRedeemed = (bonus: BonusRedemptionRecord | null | undefined) =>
  Boolean(bonus && !bonus.redeemable && bonus.unavailable_reason === 'limit_reached')
